module.exports = __webpack_public_path__ + "static/media/Transformer.b2a65067.png";